module.exports = __webpack_public_path__ + "img/Burundi.737e8df4.svg";